import Dotdotdot from "react-dotdotdot"

interface TruncatedTextProps {
    lines: number
    children: React.ReactNode
}

function TruncatedText({ lines, children } : TruncatedTextProps) {
    return <Dotdotdot clamp={lines}>
        {children}
    </Dotdotdot>
}

export default TruncatedText